export default "__VITE_ASSET__GaVi_jm2__"